import _ from "lodash";
import Images from "../../constants/lotto5Images";
import {Jackpot} from "../jackpot/JackpotValue";
import Paginate from "../table/Paginate";
import React, {memo, useState} from "react";
import {getDateDef} from "../../utils/dateUtils";
import {isOddEven} from "../../constants/general";
import {useTranslation} from "react-i18next";

const MainTableResult = ({items, totals, size, onChangePage}) => {

    const {t} = useTranslation();
    const [page, setPage] = useState(1)

    return <div className="wrapper-game-content">
        <div className="table-container pt-0">
            <table className="table-custom">
                <thead>
                <tr>
                    <th className="text-center">{t("labels:drawing.no")}</th>
                    <th className="text-center">{t("labels:drawing.date")}</th>
                    <th className="text-center">{t("labels:drawing.drawCode")}</th>
                    <th className="text-center">{t("labels:drawing.result")}</th>
                    <th className="text-center">{t("labels:drawing.underOver")}</th>
                    {isOddEven &&
                        <th className="text-center">{t("labels:drawing.oddEvenCode")}</th>}
                    <th className="text-center">{t("labels:drawing.range")}</th>
                    {/*<th className="text-center">{t("labels:drawing.bonus")}</th>*/}
                    <th className="text-center">{t("labels:drawing.jackpot")}</th>
                    <th className="text-center">{t("labels:drawing.detail")}</th>
                </tr>
                </thead>
                <tbody>
                {
                    _.isEmpty(items)
                        ? <tr>
                            <td colSpan={10}><img className="data-not-found-img"
                                                  src={Images.dataNotFound} alt="..."/></td>
                        </tr>
                        : items.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">{getDateDef(item.createdAt)}</td>
                                    <td className="text-center">
                                                                    <span
                                                                        className="title-ticket-id-btn">{item.drawLabel}</span>
                                    </td>
                                    <td className="text-center">{item.result}</td>
                                    <td className={"text-center left-bet-type-" + item.underOverCode}>{t("labels:betPrefix." + item.underOverCode)}</td>
                                    {isOddEven && <td
                                        className={"text-center left-bet-type-" + item.oddEvenCode}>{t("labels:betPrefix." + item.oddEvenCode)}</td>}
                                    <td className="text-center"><span
                                        className={"text-white left-bet-type-" + item.rangeCode}>{t("labels:betPrefix." + item.rangeCode)}</span>
                                    </td>
                                    {/*<td className="text-center">*/}
                                    {/*    {!isBonus(item.bonusCode) ? <span>---</span> : <span*/}
                                    {/*        className={"text-white left-bet-type-" + item.bonusCode}>{t("labels:betPrefix." + item.bonusCode)}</span>}*/}
                                    {/*</td>*/}
                                    <td className={"text-center"}>
                                        <Jackpot item={item} t={t}/>
                                    </td>
                                    <td className="text-center">{item.detail}</td>
                                </tr>
                            );
                        })
                }
                </tbody>
            </table>
        </div>

        {
            totals > 0
                ? <div className="mt-2">
                    <Paginate
                        page={page}
                        size={size}
                        total={totals}
                        onChange={page => {
                            setPage(page);
                            onChangePage({page});
                        }}
                    />
                </div>
                : null
        }

    </div>

}

export default memo(MainTableResult);